import * as React from "react";

function BadgeDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0c36.8 0 68.8 20.7 84.9 51.1 32.9-11 69.2-2.14 96.1 23.88 26 26.02 33.1 63.22 23.9 96.12 30.4 16.1 51.1 48.1 51.1 84.9 0 36.8-20.7 68.8-51.1 84.9C471 373.8 463 410.1 437 437c-26.9 26-63.2 33.1-96.1 23.9-16.1 30.4-48.1 51.1-84.9 51.1-36.8 0-68.8-20.7-84.9-51.1C138.2 471 101 463 74.98 437 48.96 410.1 41 373.8 51.1 340.9 20.7 324.8 0 292.8 0 256c0-36.8 20.7-68.8 51.1-84.9-11-32.9-2.14-70.1 23.88-96.12C101 48.96 138.2 41 171.1 51.1 187.2 20.7 219.2 0 256 0zm20.1 149.3c0-11.1-9-20.1-19.2-20.1-11.1 0-20.1 9-20.1 20.1v8.5c-6.7 1.3-13.1 3.3-19 5.9-16.1 7.3-29.9 20.8-33.3 39.4-1.9 11.8-.8 22.3 3.6 31.7 4.4 9.3 11.4 16 18.5 20.8 12.6 8.5 29.3 13.6 41.5 17.5l3.2.7c15.4 4.7 26.3 8.3 33.2 13.3 3 2.2 4.3 4 4.9 5.4.6 1.4 1.3 3.9.4 8.7-.8 4.7-3.5 8.6-10.1 11.4-7.3 3.1-19.6 4.6-33.3 2.3-6.8-1.1-19-5.3-29.6-8.9-2.4-.8-4.7-1.6-6.9-2.3-10.5-3.5-21.8 2.2-25.3 12.6-3.5 10.5 2.2 21.9 12.6 25.3 1.4.5 3.1 1.1 5.1 1.7 9.2 3.2 23.9 8.2 34.5 10.5v8.9c0 11.1 9 20.1 20.1 20.1 10.2 0 19.2-9 19.2-20.1v-8c7.3-1.1 13.5-2.8 19.3-5.3 16.9-7.2 30.3-21.1 33.8-41.4 2-11.1 1.1-21.8-3.1-31.4-5-9.6-10.9-17.5-18.1-21.8-13.1-9.6-30.8-15-44.3-19l-.8-.3c-15.6-4.7-26.7-8.1-33.8-13-4-2.1-4.3-3.7-4.8-4.8-.4-.8-1.1-3.6-.4-6.9.6-3.1 2.9-7.2 10.4-10.6 7.6-3.5 19.2-5.3 33.1-3.1 4.9.8 20 3.7 24.3 4 10.7 3.7 21.7-2.6 24.5-13.3 2.9-10.7-3.5-21.6-14.2-24.5-5.2-1.4-17.8-3.9-25.9-5.1v-8.9z"
  }));
}

const ForwardRef = React.forwardRef(BadgeDollarIcon);
export default ForwardRef;